
namespace TabAurous.Finance {

    @Serenity.Decorators.registerClass()
    export class PaymentGrid extends _Ext.GridBase<PaymentRow, any> {
        protected getColumnsKey() { return 'Finance.Payment'; }
        protected getDialogType() { return PaymentDialog; }
        protected getIdProperty() { return PaymentRow.idProperty; }
        protected getInsertPermission() { return PaymentRow.insertPermission; }
        protected getLocalTextPrefix() { return PaymentRow.localTextPrefix; }
        protected getService() { return PaymentService.baseUrl; }

        constructor(container: JQuery) {
            super(container);
        }
        protected addButtonClick() {

            let now = new Date(); 
            var userDefinition = Q.Authorization.userDefinition;
            var voucherNo = FormatHelper.GetVoucherNo(4);
            this.editItem(<PaymentRow>{
                VoucherNo: voucherNo,
                TransDate: now.toString(), 
                VoucherTypeId: 4,
                FinancialYearId: userDefinition.FinancialYearId,
                CompanyId: userDefinition.CompanyId, 
                UserId: userDefinition.UserId,
                CurrencyId: userDefinition.CurrencyId,
                EnteredBy: userDefinition.UserId,
            }); 
        }
    }
}